<template>
<div class='column-tree-table-column' :id='data.id'>
  <div class='column-tree-table-column__header'>
      <div class='column-tree-table-column__header__title'>
        <a :href='data.url' target="_blank">
          {{data.name}}
        </a>
      </div>
      <div class='column-tree-table-column__header__subtitle'>{{cellsCountFormatted}} techniques</div>
    </div>
  <div class='column-tree-table-column__cells' v-if='hasCells'>
    <column-tree-table-default-cell v-for='cell in data.cells' :key='cell.id' :data='cell' :layer='layer' :focus='focus' :color-map='colorMap' :data-version='dataVersion' :tactic="tacticSlug"/>
  </div>
</div>
</template>

<script>
import ColumnTreeTableDefaultCell from '@/components/ColumnTreeTable/ColumnTreeTableDefaultCell.vue';

export default {
  name: 'ColumnTreeTableColumn',
  components: { ColumnTreeTableDefaultCell },
  props: {
    data: {
      required: true,
      type: Object,
    },
    layer: {
      required: false,
      type: Array,
      default: () => [],
    },
    focus: {
      required: false,
      type: String,
      default: '',
    },
    colorMap: {
      required: false,
      type: Object,
      default: () => undefined,
    },
    dataVersion: {
      required: true,
      type: Number,
    },
  },
  computed: {
    cellsCountFormatted() {
      return this.data?.cells?.length || 0;
    },
    hasCells() {
      return this.cellsCountFormatted > 0;
    },
    tacticSlug() {
      return this.data ? this.data.name.toLowerCase().replace(/\s+/g, '-') : '';
    },
  },
};
</script>

<style lang='scss' scoped>
.column-tree-table-column {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  align-content: center;

  &:hover {
    background-color: var(--bg-tertiary);
    // When hovering column, use lighter background for header to highlight it
    --header-bg-color: var(--bg-tertiary);
    --corner-bg-color: var(--bg-tertiary);
  }

  &__cells {
    margin-top: 8px;
    padding-right: 10px;
    padding-left: 10px;
  }

  &__header {
    display: flex;
    flex-direction: column;
    min-width: 123px;
    width: 100%;
    align-items: center;
    align-content: center;
    background-color: var(--header-bg-color, var(--bg-primary));
    border-bottom: 1px solid var(--border-primary);

    &__title {
      margin-right: 10px;
      word-break: break-word;
      height: 50px;
      text-align: center;

      a {
        color: var(--text-primary);
        text-decoration: none;

        &:hover {
          color: var(--brand-primary);
        }
      }
    }

    &__subtitle {
      justify-content: center;
      margin-right: 15px;
      font-size: 10px;
      margin-bottom: 4px;
      color: var(--text-secondary);
    }
  }
}
</style>
